import type {
  CreateBatchForm,
  DocumentTypeFilter,
  ProvisioningStatusFilter,
} from './types';

export const initialForm: CreateBatchForm = {
  stateId: null,
  countyId: null,
  mode: 'provision',
  documentType: 'all',
  provisioningStatus: 'all',
  promptVersionIds: [],
  provisionedDateStart: null,
  provisionedDateEnd: null,
};

export const DOCUMENT_TYPE_OPTIONS: {
  id: DocumentTypeFilter;
  label: string;
}[] = [
  { id: 'all', label: 'All Document Types' },
  { id: 'courthouse', label: 'Courthouse' },
  { id: 'non_courthouse', label: 'Non-Courthouse' },
  { id: 'regulatory', label: 'Regulatory' },
];

export const PROVISIONING_STATUS_OPTIONS: {
  id: ProvisioningStatusFilter;
  label: string;
}[] = [
  { id: 'all', label: 'All Documents' },
  { id: 'provisioned', label: 'Provisioned Only' },
  { id: 'not_provisioned', label: 'Not Provisioned Only' },
];

export const CATEGORY_LABELS: Record<string, string> = {
  document_metadata: 'Courthouse',
  regulatory_document_fields: 'Regulatory',
};

export const formatCategoryLabel = (category: string) =>
  CATEGORY_LABELS[category] ??
  category.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export const STATUS_FILTER_OPTIONS = [
  { id: 'all', label: 'All Statuses' },
  { id: 'pending', label: 'Pending' },
  { id: 'processing', label: 'Processing' },
  { id: 'processed', label: 'Processed' },
  { id: 'failed', label: 'Failed' },
  { id: 'cancelled', label: 'Cancelled' },
];

export const LOOKBACK_OPTIONS = [
  { id: 'all', label: 'All Time' },
  { id: '24', label: 'Last 24 hours' },
  { id: '48', label: 'Last 48 hours' },
  { id: '72', label: 'Last 72 hours' },
  { id: '168', label: 'Last 7 days' },
  { id: '720', label: 'Last 30 days' },
];
